/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from "./api";
import { sanitizeQueryParams } from "../utility/helpers/apiHelper";

export interface SubcategoryOption {
  id: number;
  categoryId: number;
  name: string;
  categoryName?: string;
}

export class SubcategoryService {
  async getAllSubcategories(query?: {
    name?: string;
    categoryId?: number | string;
    orderBy?: string;
    orderDirection?: string;
  }) {
    return apiService.get("/subcategories/all", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getSubcategories(query?: Record<string, any>) {
    return apiService.get("/subcategories", {
      params: sanitizeQueryParams(query || {}),
    });
  }
}

export const subcategoryService = new SubcategoryService();
